import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    stretch: Boolean
  }

  connect() {
    if (this.stretchValue) {
      this.stretchBanner();
    }
  }

  stretchBanner() {
    const image = this.element.querySelector("img");
    image.src = image.dataset.src;

    image.onload = () => {
      const imageHeight = this.element.querySelector('img').height;
      const parentElement = this.element.closest("div");

      const container = parentElement.parentElement;
      const containerHeight = container.clientHeight;
      container.style.height = `${imageHeight + containerHeight}px`;

      parentElement.style.height = `${imageHeight}px`;
      parentElement.nextElementSibling.style.marginTop = `${imageHeight}px`;
    };
  }
}
